var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFb = function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 92 92"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m56.983 48.761 1.305-8.288H50.25v-5.388c0-2.267 1.122-4.481 4.71-4.481h3.705v-7.059a44.902 44.902 0 0 0-6.523-.557c-6.614 0-10.932 3.976-10.932 11.164v6.32h-7.332v8.29h7.332V68.81h9.04V48.761h6.732Z"
  })));
};
export default SvgFb;